import { render, staticRenderFns } from "./SignInFour.vue?vue&type=template&id=24f7e295&scoped=true&"
import script from "./SignInFour.vue?vue&type=script&lang=js&"
export * from "./SignInFour.vue?vue&type=script&lang=js&"
import style0 from "./SignInFour.vue?vue&type=style&index=0&id=24f7e295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7e295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCardText,VTextField})
